import {ActivityGaugeSchema} from "../activitygauge/ActivityGaugeSchema";
import {BarChartSchema} from "../barchart/BarChartSchema";
import {BubbleChartSchema} from "../bubblechart/BubbleChartSchema";
import {CardSchema} from "../../layout/wrappers/CardSchema";
import {FileDropZoneSchema} from "../dropzone/FileDropZoneSchema";
import {GanttSchema} from "../gantt/GanttSchema";
import {KeyAttributesSchema} from "../keyattributes/KeyAttributesSchema";
import {KPIGroupSchema} from "../performanceindicator/KPIGroupSchema";
import {MetricCardSchema} from "../metriccard/MetricCardSchema";
import {PerformanceIndicatorSchema} from "../performanceindicator/PerformanceIndicatorSchema";
import {PieChartSchema} from "../piechart/PieChartSchema";
import {ScatterChartSchema} from "../scatterchart/ScatterChartSchema";
import {SmartDateSchema} from "../smartdate/SmartDateSchema";
import {SmartDataGridSchema} from "../smartdatagrid/SmartDataGridSchema";
import {SmartListSchema} from "../smartlist/SmartListSchema";
import {SmartTableSchema} from "../table/SmartTableSchema";
import {TabSchema} from "../tabs/TabSchema";
import {TimeSeriesChartSchema} from "../timeseries/TimeSeriesChartSchema";
import {TreeMapChartSchema} from "../treemapchart/TreemapChartSchema";
import {TrendsInsightsSchema} from "../trendsinsights/TrendsInsightsSchema";
import {WordcloudChartSchema} from "../wordcloudchart/WordcloudChartSchema";
import {WriteupSchema} from "../writeup/WriteupSchema";
import {ModelTypeGroupSchema} from "../modeltypeindicator/ModelTypeGroupSchema";
import {ModelTypeIndicatorSchema} from "../modeltypeindicator/ModelTypeIndicatorSchema";

export const findXConfigSchema = (configuration, schemaType) => {
	let schema;
	let tabs;

	if (schemaType) {
		switch (schemaType.toLowerCase()) {
			case 'activitygauge':
				schema = ActivityGaugeSchema;
				break;
			case 'barchart':
				schema = BarChartSchema;
				break;
			case 'bubblechart':
				schema = BubbleChartSchema;
				break;
			case 'card':
				schema = CardSchema;
				break;
			case 'datagrid':
				schema = SmartDataGridSchema;
				break;
			case 'dropzone':
				schema = FileDropZoneSchema;
				break;
			case 'gantt':
				schema = GanttSchema;
				break;
			case 'keyattributes':
				schema = KeyAttributesSchema;
				break;
			case 'kpigroup':
				schema = KPIGroupSchema;
				break;
			case 'metriccard':
				schema = MetricCardSchema;
				break;
			case 'modeltypegroup':
				schema = ModelTypeGroupSchema;
				break;
			case 'modeltypeindicator':
				schema = ModelTypeIndicatorSchema;
				break;
			case 'performanceindicator':
				schema = PerformanceIndicatorSchema;
				break;
			case 'piechart':
				schema = PieChartSchema;
				break;
			case 'scatterchart':
				schema = ScatterChartSchema;
				break;
			case 'smartdate':
				schema = SmartDateSchema;
				break;
			case 'list':
				schema = SmartListSchema;
				break;
			case 'table':
				schema = SmartTableSchema;
				break;
			case 'tab':
				if (configuration?.tabs) {
					tabs = configuration.tabs;
				}
				schema = TabSchema;
				break;
			case 'timeserieschart':
				schema = TimeSeriesChartSchema;
				break;
			case 'treemapchart':
				schema = TreeMapChartSchema;
				break;
			case 'trendsinsights':
				schema = TrendsInsightsSchema;
				break;
			case 'wordcloudchart':
				schema = WordcloudChartSchema;
				break;
			case 'writeup':
				schema = WriteupSchema;
				break;
			default:
				return '';
		}
	}

	return {schema, tabs}
}